var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'history-card',
        _vm.shipment.recently_updated ? 'updated-now' : '' ]},[_c('HistoryCardInfo',{attrs:{"shipment":_vm.shipment,"userId":_vm.userId},on:{"click":_vm.openInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }